import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { IoIosArrowUp } from "react-icons/io";

import { SetShowInAppNotificationOverlay, SetInAppNotificationOverlayData } from "../../../redux/v2/utils/actions";
import { InAppNotificationClicked, PushNotificationClicked } from "../../../redux/v2/user/actions";
import useSVG from "../../../hooks/useSVG";

function NotificationItem(props) {
    let { title = "", description = "", date = null, viewed = 0, icon = {}, gradient = "", notification = {}, closeNotificationDrawer = () => {} } = props;

    const navigate = useNavigate();
    const { UseProgramSVG, UseChalengesSVG, UseNumberSVG, UseMainSVG } = useSVG();
    const [seeMore, setSeeMore] = useState(false);

    let svg;
    if (icon?.type == "program") {
        svg = UseProgramSVG(icon?.name);
    } else if (icon?.type == "challenge") {
        svg = UseChalengesSVG(icon?.name);
    } else if (icon?.type == "number") {
        svg = UseNumberSVG(icon?.name);
    } else if (icon?.type == "main") {
        svg = UseMainSVG(icon?.name);
    }

    const redirectTo = () => {
        if (notification?.type == "push") {
            closeNotificationDrawer();
            navigate(notification?.metadata?.route || "/");

            if (!viewed) {
                props.PushNotificationClicked(notification?.metadata?.pnlID);
            }
        } else if (notification?.type == "in-app") {
            props?.SetInAppNotificationOverlayData(notification?.metadata);
            props?.SetShowInAppNotificationOverlay(true);

            if (!viewed) {
                props.InAppNotificationClicked(notification?.metadata?.ianID);
            }
        } else if (notification?.type == "toggle") {
            closeNotificationDrawer();
            navigate("/settings/notification");
        }
    };

    let formatedDate = moment(new Date(date)).format("MM/DD/YYYY");
    gradient = gradient?.split("-");

    return (
        <div className={`notification-item ${!viewed && "ni-not-viewed"} ${seeMore && "see-more"}`} style={!viewed ? { borderRight: `3px solid ${gradient[1]}` } : null}>
            <div
                className="ni-left-info"
                onClick={() => {
                    redirectTo();
                }}
            >
                <div className="ni-icon-wrapper" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}>
                    {svg}
                </div>
            </div>
            <div
                className="ni-right-info"
                onClick={() => {
                    redirectTo();
                }}
            >
                <h5 className={`ni-ri-title ${!description && "clamp-2"}`}>{title}</h5>
                <p className="ni-ri-desc">{description}</p>
                <h6 className="ni-ri-date">{date && `${formatedDate}`}</h6>
            </div>
            {(description && date) && (
                <div className="ni-right-icons">
                    <IoIosArrowUp
                        onClick={() => {
                            setSeeMore(!seeMore);
                        }}
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    SetShowInAppNotificationOverlay,
    SetInAppNotificationOverlayData,
    InAppNotificationClicked,
    PushNotificationClicked,
})(NotificationItem);
